import { makeLinkWithQueryParams } from '../intents/linkUtils';
import { startupApplication, nonprofitsApplication } from './productLinks';
export const getHubSpotForStartupsRedirect = ({
  portalId,
  hublet,
  intentLink,
  isNewPortal = false
}) => makeLinkWithQueryParams({
  link: startupApplication({
    portalId,
    hublet
  }),
  queryParamsToInclude: {
    via: isNewPortal ? 'hubspot-for-startups-signup' : 'hubspot-for-startups-existing-account',
    redirect: intentLink
  },
  hublet
});
export const getHubSpotForNonprofitsRedirect = ({
  portalId,
  hublet,
  intentLink
}) => makeLinkWithQueryParams({
  hublet,
  link: nonprofitsApplication({
    portalId,
    hublet
  }),
  queryParamsToInclude: {
    via: 'hubspot-for-nonprofits-signup',
    redirect: intentLink
  }
});